/**
 * Shared escaper for text interpolated into an HTML string (e.g. the `confirmDialog` message).
 * Reuse it rather than writing another copy.
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
